import React from 'react';
import styles from './About.module.css';
import heroImg from '../../assets/images/gallery_2.jpg';
import founderImg from '../../assets/images/founder.jpeg';
import directorImg from '../../assets/images/director_new.jpg';

const About = () => (
  <main>
    {/* Page Hero */}
    <section className="page-hero" data-theme="dark">
      <img src={heroImg} alt="Students in uniform" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3))', zIndex: 0 }} />
      <div className="container page-hero__content">
        <p className="page-hero__breadcrumb">HOME / ABOUT US</p>
        <h1 className="page-hero__title">
          <span className="page-hero__title-top" style={{ color: '#FFFFFF', opacity: 1 }}>ABOUT</span>
          <span className="page-hero__title-bottom" style={{ color: 'var(--cyan)' }}>VIN FLY.</span>
        </h1>
        <p className="page-hero__sub">
          Building India's finest aviation professionals.
        </p>
      </div>
    </section>

    {/* Leadership Messages */}
    <section className="section-py" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">

        {/* Founder's Message */}
        <div className={`${styles.modernCard} reveal`}>
          <div className={styles.portraitColumn}>
            <div className={styles.portraitFrame}>
              <img src={founderImg} alt="Founder VIN Fly Aviation" className={styles.portraitImg} />
              <div className={styles.portraitLabel}>
                <h3 className={styles.portraitName} style={{ textTransform: 'none' }}>Hon. Mr. Vinayakrao Bhongale</h3>
                <p className={styles.portraitTitle}>Founder & Chairman<br />VPB Education Foundation</p>
              </div>
            </div>
          </div>
          <div className={styles.messageColumn}>
            <div className={styles.quoteIcon}>"</div>
            <p className="label" style={{ marginBottom: 8 }}>Leadership</p>
            <h2 className={styles.leadershipHeading} style={{ position: 'relative', zIndex: 1 }}>Founder's Message</h2>
            <div className="label-rule" />
            <div className={styles.messageText}>
              <p>At VIN Fly Aviation Academy, under VPB Education Foundation, we believe that the sky is not the limit—it is just the beginning.</p>
              <p>Our mission is to nurture aspiring aviation professionals with the knowledge, discipline, and confidence required to excel in this dynamic and ever-evolving industry.</p>
              <p>Aviation demands precision, commitment, and a passion for excellence. At VIN Fly, we are dedicated to creating an environment that fosters these qualities through world-class training, experienced faculty, and a curriculum designed to meet global standards.</p>
              <p>We aim not only to educate but to inspire, guiding our students to become skilled professionals and responsible individuals.</p>
              <p>As Chairman, I take immense pride in the achievements of our students and the dedication of our team. Together, we are building a future where dreams take flight and careers soar to new heights.</p>
              <p>I invite you to join us on this exciting journey and become a part of a community that is shaping the future of aviation.</p>
            </div>
          </div>
        </div>

        {/* Director's Message */}
        <div className={`${styles.modernCard} ${styles.reverse} reveal`} style={{ marginTop: '4rem' }}>
          <div className={styles.portraitColumn}>
            <div className={styles.portraitFrame}>
              <img src={directorImg} alt="Director VIN Fly Aviation" className={styles.portraitImg} />
              <div className={styles.portraitLabel}>
                <h3 className={styles.portraitName} style={{ textTransform: 'none' }}>Hon'ble Kavita Kadu Patil</h3>
                <p className={styles.portraitTitle}>Director<br />VPB Education Foundation & VIN Fly Aviation Academy</p>
              </div>
            </div>
          </div>
          <div className={styles.messageColumn}>
            <div className={styles.quoteIcon}>"</div>
            <p className="label" style={{ marginBottom: 8 }}>Visionary</p>
            <h2 className={styles.leadershipHeading} style={{ position: 'relative', zIndex: 1 }}>Director's Message</h2>
            <div className="label-rule" />
            <div className={styles.messageText}>
              <p>Greetings from VIN Fly Aviation Academy, under VPB Education Foundation, Pune. It gives me great pleasure to welcome you to an institute committed to shaping the future of aspiring aviation professionals.</p>
              <p>At VIN Fly Aviation Academy, we believe aviation is more than just a career—it is a journey of discipline, confidence, global exposure, and excellence in service.</p>
              <p>Our mission is to equip students with the right blend of knowledge, skills, and attitude required to succeed in this dynamic industry.</p>
              <p>As Director, my vision is to deliver quality, skill-based education that focuses on practical learning, industry readiness, and personality development. Our programs are carefully curated to match current industry standards and expectations.</p>
              <p>We are not just training students—we are building careers and transforming lives. With dedicated mentorship, modern training methods, and a strong focus on employability, we ensure that every student is prepared to achieve success.</p>
              <p>I warmly invite you to be a part of this journey towards a bright and rewarding future.</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    {/* About the Academy Details */}
    <section className="section-py" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className={styles.academyDetailsGrid}>
          <div className="reveal">
            <p className="label">INSTITUTIONAL CREDENTIALS</p>
            <h2 className={styles.academyTitle}>About the Academy.</h2>
            <div className="label-rule" />
            <div className={styles.academyInfo}>
              <div className={styles.infoBlock}>
                <h4>Location & Governance</h4>
                <p>VIN Fly Aviation Academy, Moshi, PCMC, Pune – 412105, Maharashtra.</p>
                <p>This academy operates as a unit of <strong>VPB Education Foundation, Pune</strong>.</p>
              </div>
              <div className={styles.infoBlock}>
                <h4>MCA Registration</h4>
                <p>Registered under the Ministry of Corporate Affairs, Government of India, Companies Act, 2013 (18 of 2013).</p>
                <p>Corporate Identity Number (CIN): <span className="accent" style={{ fontWeight: 'bold', color: 'var(--blue)' }}>U85490PN2024NPL231929</span></p>
              </div>
              <div className={styles.infoBlock}>
                <h4>Skill University Partnership</h4>
                <p>Certificate No.: <span style={{ fontWeight: 'bold' }}>MSU/2025-26/396</span></p>
                <p>Official partnership with <strong>Medhavi Skill University</strong> (Skill India & NSDC).</p>
              </div>
            </div>
          </div>
          <div className={`${styles.statsFeatured} reveal`}>
            <div className={styles.statBox}>
              <span className="stat-num">MSU</span>
              <p>PARTNERED ACADEMY</p>
            </div>
            <div className={styles.statBox}>
              <span className="stat-num">100%</span>
              <p>SKILL FOCUSED</p>
            </div>
            <div className={styles.statBox}>
              <span className="stat-num">U85490</span>
              <p>CIN REGISTERED</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Mission & Vision */}
    <section className={styles.mv}>
      <div className={`${styles.missionPanel} reveal`}>
        <p className="label" style={{ color: 'rgba(255,255,255,0.70)', marginBottom: 16 }}>OUR MISSION</p>
        <h2 className={styles.mvTitle}>Why We Train.</h2>
        <p className={styles.mvBody}>To provide world-class aviation education that empowers students with the knowledge, skills, and confidence to excel in the global aviation industry. We are committed to nurturing talent through innovative teaching methods, practical training, and personalized mentorship.</p>
      </div>
      <div className={`${styles.visionPanel} reveal`}>
        <p className="label" style={{ marginBottom: 16 }}>OUR VISION</p>
        <h2 className={styles.mvTitle} style={{ color: 'var(--ink)' }}>Where We're Going.</h2>
        <p className={styles.mvBody}>To be India's most trusted aviation training institute, recognized for producing industry-ready professionals who set benchmarks in service excellence. We envision a future where every VIN Fly graduate becomes a leader in the aviation and hospitality sectors.</p>
      </div>
    </section>

  </main>
);

export default About;
